import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Select } from "antd";
import "@/assets/audioAddMusic.less";

const { Option } = Select;

const AudioWorkFooterRender = ({ handleSubmit, format, handleFormatChange }) => {
  const { t } = useTranslation(["audioAddMusic", "common"]);
  return (
    <div className="workplace-footer">
      <div className="ouput-operation">
        <div>
          <span className="label">{t("Format")}</span>
          <Select
            onChange={handleFormatChange}
            className="dark-select"
            dropdownClassName="dark-select-dropdown"
            defaultValue={format}
            style={{ width: 180 }}
          >
            <Option value="wav">WAV</Option>
            <Option value="mp3">MP3</Option>
            <Option value="m4a">M4A</Option>
            <Option value="aac">AAC</Option>
            <Option value="ogg">OGG</Option>
          </Select>
        </div>
        <Button type="primary" onClick={() => handleSubmit(format)}>
          {t("common:Export")}
        </Button>
      </div>
    </div>
  );
};

export default AudioWorkFooterRender;
